import { createComponent } from "@opendash/state";
import { Spin } from "antd";
import * as React from "react";
import styled from "styled-components";
import { $parse } from "../..";
export const AuthLayout = createComponent(function AuthLayout({ children, width = 600, }) {
    const currentTenant = $parse.auth.currentTenant;
    return (React.createElement(Container, null,
        React.createElement(Content, { width: width },
            (currentTenant === null || currentTenant === void 0 ? void 0 : currentTenant.logo) && (React.createElement("img", { src: currentTenant === null || currentTenant === void 0 ? void 0 : currentTenant.logo, alt: currentTenant === null || currentTenant === void 0 ? void 0 : currentTenant.label })),
            $parse.auth.loading ? React.createElement(Spin, null) : React.createElement(Box, { width: width }, children)),
        React.createElement(Container, null)));
});
export const Container = styled.div `
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden;

  height: 100%;
  width: 100%;
  padding: 10px;
`;
export const Content = styled.div `
  width: 100%;
  max-width: ${(p) => p.width}px;
  // padding: 24px 24px;

  z-index: 2;

  img {
    width: auto;
    max-width: 60%;
    display: block;
    margin: 0 auto;
    margin-bottom: 24px;
  }
`;
export const Box = styled.div `
  padding: 24px 24px;
  background: white;
  border-bottom: 3px solid var(--ant-primary-color);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
`;
export const Title = styled.div `
  text-align: center;
  font-size: 20px;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 5px;
`;
export const SwitchState = styled.div `
  text-align: center;
  font-size: 12px;
  margin-top: 20px;
`;
export const Background = styled.div `
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  height: 100vh;
  width: 100vw;

  /* background: black; */

  z-index: 1;

  ::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    height: 100vh;
    width: 100vw;

    opacity: 0.5;
    filter: blur(5px);
    transform: scale(1.1);

    background-attachment: fixed;
    background-position: center;
    background-size: cover;
  }
`;
//# sourceMappingURL=data:application/json;base64,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